
import { get, post } from '../../services/api';

export const fetchVendeursParStatut = async (statut) => {
  const res = await get(`/vendeurs/statut/${encodeURIComponent(statut)}`);
  return res.data;
};

export const inscrireVendeur = async (formData) => {
  // formData est déjà un FormData
  const res = await post('/vendeurs/register', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};
